// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const GitHubAppKindSchema = z.enum(['BASIC','FULL'] as const);

export type GitHubAppKindType = `${z.infer<typeof GitHubAppKindSchema>}`

export default GitHubAppKindSchema;
